export default __webpack_public_path__ + "static/media/about_1.1d2bf74a.jpg";